import { CollectionDetailView } from '@/features/AssetCollection/CollectionDetailView/CollectionDetailView';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/asset_collection/$collectionId/assets/',
)({
    component: CollectionDetailView,
});
